import APP_STORE from '@icons/app-store-btn.svg';
import PLAY_STORE from '@icons/play-store.svg';
import { ProductInfoData } from '@core/interactors/get-product-info.interactor';
import { getAndroidOrIOS } from '../../utils/index';
import './style.scss';

const androidLink =
	'https://play.google.com/store/apps/details?id=com.drxasia.app';
const iphoneLink = 'https://apps.apple.com/id/app/drx-sportnet/id6451012243';

interface ProductInfoPropTypes {
	data: null | ProductInfoData;
}
const SuggestApp: React.FC<ProductInfoPropTypes> = ({ data }) => {
	const onClickAppBtn = () => {
		window.location.href =
			getAndroidOrIOS() === 'ios' ? iphoneLink : androidLink;
	};

	if (!data) {
		return (
			<div className='suggest-app-wrapper'>
				<span className='intro-text'>Join DRX Movement!</span>
				<span className='description'>
					Download the DRX Sportnet app now to enjoy the features we have!
				</span>

				<div className='flex-box'>
					<button onClick={onClickAppBtn}>
						<img src={APP_STORE} alt='app-store' />
					</button>
					<button onClick={onClickAppBtn}>
						<img src={PLAY_STORE} alt='play-store' />
					</button>
				</div>
			</div>
		);
	}

	return (
		<div className='suggest-app-wrapper'>
			<span className='intro-text'>Don't have the DRX App? Don't worry!</span>
			<span className='description'>
				Download the DRX Sportnet app now to enjoy the features we have!
			</span>

			<div className='flex-box'>
				<button onClick={onClickAppBtn}>
					<img src={APP_STORE} alt='app-store' />
				</button>
				<button onClick={onClickAppBtn}>
					<img src={PLAY_STORE} alt='play-store' />
				</button>
			</div>
		</div>
	);
};

export default SuggestApp;
